// extracted by mini-css-extract-plugin
export default {"parent":"cartSlot_parent__w3W33","parentContent":"cartSlot_parentContent__K+YBp"};